export default __webpack_public_path__ + "static/media/Zany.e821d1a0.svg";